import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-heading',
    imports: [CommonModule],
    templateUrl: './page-heading.component.html',
    styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent {
  @Input() pageTitle!: string;
  @Input() pageDescription!: string;
  @Input() flexHeader: boolean = false;
}
